document.addEventListener('DOMContentLoaded', (event) => {
  const params = new URLSearchParams(window.location.search)
  const modal = params.get('modal')

  if (modal) {
    const modalElement = document.getElementById(modal)
    if (modalElement) {
      window.dispatchEvent(
        new CustomEvent('drawer', {
          bubbles: true,
          composed: true,
          detail: {
            id: modal,
          },
        })
      )
    }
  }
})
